import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { isMention as hasMention, getUserById, MENTION_REGEX } from './helpers';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';

const USERNAME = 1;
const USERID = 2;

const styles = () => ({
  mentionContainer: {
    color: '#00A1FB',
    backgroundColor: '#E0F3FE'
  }
});

export class CommentString extends PureComponent {
  static propTypes = {
    users: PropTypes.array.isRequired,
    comment: PropTypes.string.isRequired
  };
  state = {
    isMention: false,
    user: { username: '', firstName: '', lastName: '' }
  };
  componentDidMount() {
    const { comment, users } = this.props;
    if (hasMention(comment)) {
      const regex = RegExp(MENTION_REGEX, 'gm');
      const matches = regex.exec(comment);
      const user = getUserById(matches[USERID], users);
      this.setState({
        isMention: true,
        user: {
          firstName: user.firstName,
          lastName: user.lastName,
          username: matches[USERNAME]
        }
      });
    }
  }
  render() {
    const { comment, classes } = this.props;
    const { isMention, user } = this.state;
    return (
      <Fragment>
        {isMention ? (
          <Tooltip
            title={`${user.firstName} ${user.lastName}`}
            placement="top-start"
          >
            <span className={classes.mentionContainer}>{user.username}</span>
          </Tooltip>
        ) : (
          <span>{comment}</span>
        )}
      </Fragment>
    );
  }
}

export default withStyles(styles)(CommentString);
